import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { SzIconComponent, SzIconName } from '../../display/sz-icon';
import { SzIconButtonSize, SzIconButtonVariant } from './sz-icon-button.types';

@Component({
  selector: 'sz-icon-button',
  templateUrl: './sz-icon-button.component.html',
  styleUrls: ['./sz-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent]
})
export class SzIconButtonComponent {
  readonly icon: InputSignal<SzIconName> = input.required<SzIconName>();
  readonly size: InputSignal<SzIconButtonSize> = input<SzIconButtonSize>('md');
  readonly variant: InputSignal<SzIconButtonVariant> = input<SzIconButtonVariant>('default');
  readonly ariaLabel: InputSignal<string> = input.required<string>();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  readonly iconSize: Signal<number> = computed((): number => (this.size() === 'sm' ? 16 : 20));
}
